import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatarMulti = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23 31H9V26.687C9 25.474 9.725 24.38 10.846 23.915C11.981 23.445 13.67 23 16 23C18.33 23 20.019 23.445 21.154 23.916C22.275 24.38 23 25.474 23 26.687V31Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 19.836C31 19.232 30.735 18.657 30.262 18.282C29.539 17.708 28.285 17 26.5 17C24.715 17 23.461 17.708 22.738 18.282C22.265 18.657 22 19.232 22 19.836V21H31V19.836Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 14C27.8807 14 29 12.8807 29 11.5C29 10.1193 27.8807 9 26.5 9C25.1193 9 24 10.1193 24 11.5C24 12.8807 25.1193 14 26.5 14Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgAvatarMulti);
export default ForwardRef;
